import { Select, Wrap } from "@chakra-ui/react";
import FormInputWraper from "../../Components/FormInputWrapper";
import type { FormStepProps } from "../../interfaces";
import { INPUT_SIZE, INPUT_VARIANT } from "../../RegisterPage";
import { useTranslations } from "next-intl";

const GenderAndProfileInput = ({ FormController }: FormStepProps) => {
  const t = useTranslations("pages.register");
  return (
    <Wrap direction={"row"} w="full" spacing={5}>
      <FormInputWraper
        flex={1}
        isRequired
        label={t("gender")}
        field_name="gender"
        color="brandOrange.500"
        FormController={FormController}
      >
        <Select
          variant={INPUT_VARIANT}
          size={INPUT_SIZE}
          {...FormController.register("gender", {
            required: t("genderInputMessage"),
          })}
        >
          <option value={"MALE"}>{t("male")}</option>
          <option value={"FEMALE"}>{t("female")}</option>
        </Select>
      </FormInputWraper>
      <FormInputWraper
        flex={1}
        isRequired
        label={t("profile")}
        field_name="type"
        color="brandOrange.500"
        FormController={FormController}
      >
        <Select
          variant={INPUT_VARIANT}
          size={INPUT_SIZE}
          {...FormController.register("type", {
            required: t("profileInputMessage"),
          })}
        >
          <option value={"sedentary"}>{t("sedentary")}</option>
          <option value={"athlete"}>{t("athlete")}</option>
        </Select>
      </FormInputWraper>
    </Wrap >
  );
};

export default GenderAndProfileInput;
